import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_ENV === 'production') {
  console.log('production detected, initializing sentry')
  Sentry.init({
    dsn: "https://43cd0d80534548e2b1950f656b3fd172@o505316.ingest.sentry.io/4503936998768640",
    environment: 'ai-images'
  })
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
